import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import userReducer from "./reducers/user";
import plansReducer from "./reducers/plans";
import cartReducer from "./reducers/cart";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, createTransform } from "redux-persist";

const persistConfig = {
    key: "root",
    version: 1,
    storage,
    blacklist: ['plans'],
    transforms: [
        createTransform(
            (inboundState) => {
                if(!inboundState) return inboundState;
                if(typeof inboundState !== 'object') return inboundState;
                const stateToPersist = { ...inboundState };
                if(stateToPersist.error) delete stateToPersist.error;
                if(stateToPersist.loading) delete stateToPersist.loading;
                return stateToPersist;
            },
            (outboundState) => outboundState
        )
    ]
};

const Comreducer = combineReducers({
    user: userReducer,
    plans: plansReducer,
    cart: cartReducer
})

const persistReducerData = persistReducer(persistConfig, Comreducer)

export default configureStore({
    reducer: persistReducerData,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
})